import React from 'react';
import {TwitterIcon,FacebookIcon,InstagramIcon, EmailIcon, MapIcon, LinkedinIcon} from './icons';

function mapsUrl(lat, lon) {
  if ((navigator.platform.indexOf("iPhone") !== -1) ||
     (navigator.platform.indexOf("iPad") !== -1) ||
     (navigator.platform.indexOf("iPod") !== -1)) {
    return `maps://maps.google.com/maps?daddr=${lat},${lon}&amp;ll=`;
  }
  return `https://maps.google.com/maps?daddr=${lat},${lon}&amp;ll=`;
}

export const SocialButtons = ({style, twitter, facebook, instagram, linkedin, email, mapPoint, ...props}) => {
    const {twitter_url, facebook_url, instagram_url, linkedin_url, email_address, latitude, longitude} = polyphony.useState(s => s.social);
    return (
        <div style={{...style, display: 'flex', justifyContent: 'center', flexFlow: 'row wrap'}} {...props}>
            {facebook && facebook_url && <a className="social-media-button" target="_blank" rel="noreferrer" href={facebook_url}><FacebookIcon style={{margin: 20}} height={40} width={40} /></a>}
            {instagram && instagram_url && <a className="social-media-button" target="_blank" rel="noreferrer" href={instagram_url}><InstagramIcon style={{margin: 20}} height={40} width={40} /></a>}
            {twitter && twitter_url && <a className="social-media-button" target="_blank" rel="noreferrer" href={twitter_url}><TwitterIcon style={{margin: 20}} height={40} width={40} /></a>}
            {linkedin && linkedin_url && <a className="social-media-button" target="_blank" rel="noreferrer" href={linkedin_url}><LinkedinIcon style={{margin: 20}} height={40} width={40} /></a>}
            {email && email_address && <a className="social-media-button" target="_blank" rel="noreferrer" href={`mailto:${email_address}`}><EmailIcon style={{margin: 20}} height={40} width={40} /></a>}
            {mapPoint && latitude && longitude && <a className="social-media-button" target="_blank" rel="noreferrer" href={mapsUrl(latitude, longitude)}><MapIcon style={{margin: 20}} height={40} width={40} /></a>}
        </div>
    );
};

SocialButtons.defaultProps = {
    facebook: true,
    instagram: true,
    twitter: true,
    linkedin: false,
    email: false,
    mapPoint: false
};

export default SocialButtons;

